
function randomString(length = 64) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    const bytes = crypto.getRandomValues(new Uint8Array(length));
    return Array.from(bytes)
        .map(b => chars[b % chars.length])
        .join("");
}

async function sha256(text: string): Promise<ArrayBuffer> {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    return crypto.subtle.digest("SHA-256", data);
}

function base64UrlEncode(buffer: ArrayBuffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
}

export async function createPkce(): Promise<pkce> {
    const codeVerifier = randomString(128);
    const hash = await sha256(codeVerifier);
    const codeChallenge = base64UrlEncode(hash);
    return {
        codeVerifier,
        codeChallenge
    };
}

export type pkce = {
    codeVerifier: string,
    codeChallenge: string
}